import { render, staticRenderFns } from "./ImgnavItem.vue?vue&type=template&id=117103d4&scoped=true"
import script from "./ImgnavItem.vue?vue&type=script&lang=js"
export * from "./ImgnavItem.vue?vue&type=script&lang=js"
import style0 from "./ImgnavItem.vue?vue&type=style&index=0&id=117103d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117103d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117103d4')) {
      api.createRecord('117103d4', component.options)
    } else {
      api.reload('117103d4', component.options)
    }
    module.hot.accept("./ImgnavItem.vue?vue&type=template&id=117103d4&scoped=true", function () {
      api.rerender('117103d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/ImgnavItem.vue"
export default component.exports